import { SVGProps } from 'react';

const WheatOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2 22 10-10m4-4-1.17 1.17M16 8h2a4 4 0 0 0 4-4V2h-2a4 4 0 0 0-4 4zM5 19l1.53 1.53a3.5 3.5 0 0 0 4.94 0L13 19l-1.53-1.53a3.5 3.5 0 0 0-4.94 0 3.5 3.5 0 0 0 0-4.94L5 11l-1.53 1.53a3.5 3.5 0 0 0 0 4.94zm1.53-1.53L5 19m11-3-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94L8 8m3.51 3.5c-.1.72-.43 1.42-.98 1.97L9 15m1.53-1.53a3.5 3.5 0 0 1 1.97-.98m-1.59-7.23c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62m3.93 3.94c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28M2 2l20 20"
    />
  </svg>
);
export default WheatOff;
